import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authSsoCodeFlowConfig: AuthConfig = {
	responseType: 'code',
	scope: 'openid', // Ask offline_access to support refresh token refreshes
	useSilentRefresh: false, // Needed for Code Flow to suggest using iframe-based refreshes
	silentRefreshTimeout: 5000, // For faster testing
	timeoutFactor: 0.75, // if 75% of access_token lifetime has passed then refresh by refresh_token (preferable) or silent refresh (if useSilentRefresh = true)
	clearHashAfterLogin: false, // doesn`t work or hardly works
	redirectUri: window.location.origin + '/',
	silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
	issuer: environment.authSsoUrl,
	clientId: 'clientArea',
	clockSkewInSec: 30
};
